import MiddleComponent from "@/views/MiddleComponent.vue";
import AppointmentsArchive from "@/views/Practitioner/Appoinments/Archive.vue";
import EditAvailability from "@/views/Practitioner/Appoinments/EditAvailability.vue";
import ScheduleAppointment from "@/views/Practitioner/Appoinments/Schedule.vue";
import UpcomingAppointments from "@/views/Practitioner/Appoinments/Upcoming.vue";
import AppointmentsView from "@/views/Practitioner/Appoinments/View.vue";
import Patients from "@/views/Practitioner/Patients.vue";
import PractitionerSettings from "@/views/Practitioner/Settings.vue";
import PractitionerView from "@/views/Practitioner/View.vue";
import PractitionerVisitCall from "@/views/Practitioner/Visits/Call.vue";
import Schedule from "@/views/Practitioner/Visits/Request.vue";

import {
  appointmentsArchiveBreadcrumbs,
  appointmentsBreadcrumbs,
  chatBreadcrumbs,
  EditAvailabilityBreadcrumbs,
  ifAuthenticated,
  patientListBreadcrumbs,
  practitionerScheduleVisitBreadcrumbs,
  profileSettingsBreadcrumbs,
  upcomingAppointmentsBreadcrumbs,
} from "./utils";

const PractitionerRoutes = [
  {
    path: "/practitioner",
    component: PractitionerView,
    meta: {
      authorize: ["practitioner"],
    },
    redirect: "/practitioner/appointments",
    beforeEnter: ifAuthenticated,
    children: [
      {
        path: "chat",
        name: "practitionerChat",
        meta: { breadcrumbs: chatBreadcrumbs },
        component: (): unknown => import("@/views/Practitioner/Chat/Index.vue"),
      },
      {
        path: "settings",
        name: "PractitionerSettings",
        component: PractitionerSettings,
        meta: { breadcrumbs: profileSettingsBreadcrumbs },
      },
      {
        path: "patients",
        name: "Patients",
        component: Patients,
        meta: { breadcrumbs: patientListBreadcrumbs },
      },
      {
        path: "appointments",
        component: AppointmentsView,
        children: [
          {
            path: "/",
            name: "Schedule",
            component: ScheduleAppointment,
            meta: { breadcrumbs: appointmentsBreadcrumbs, layout: "default" },
          },
          {
            path: "upcoming",
            name: "Upcoming",
            component: UpcomingAppointments,
            meta: { breadcrumbs: upcomingAppointmentsBreadcrumbs, layout: "default" },
          },
          {
            path: "archive",
            name: "Archive",
            component: AppointmentsArchive,
            meta: { breadcrumbs: appointmentsArchiveBreadcrumbs, layout: "default" },
          },
          {
            path: "edit",
            name: "EditAvailability",
            component: EditAvailability,
            meta: { breadcrumbs: EditAvailabilityBreadcrumbs, layout: "edit" },
          },
        ],
      },
      {
        path: "encounters",
        component: MiddleComponent,
        children: [
          {
            path: "",
            component: MiddleComponent,
            redirect: "/practitioner/appointments",
          },
          {
            path: "schedule",
            name: "PractitionerEncounterSchedule",
            component: Schedule,
            meta: { breadcrumbs: practitionerScheduleVisitBreadcrumbs },
          },
          {
            name: "PractitionerEncounter",
            path: ":encounterId",
            component: PractitionerVisitCall,
            meta: { collapseSidebar: true },
          },
        ],
      },
    ],
  },
];
export default PractitionerRoutes;
